import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class DocumentsActions extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
        };
    }

    viewDocumentHistory = async () => {
        const { lang } = this.context;

        try {
            window.blockUI();
            const res = await axios.get(`/api/person_documents/${this.props.document.id}/logs`);
            const logs = res?.data?.data || [];

            window.unblockUI();

            const rowsHtml = logs.length
                ? logs
                    .map((l) => {
                        const status = l.status_name || `Status ${l.person_documents_statuses_id}`;
                        const createdAt = l.created_at || '';
                        return `<tr><td style="white-space:nowrap;">${createdAt}</td><td>${status}</td></tr>`;
                    })
                    .join('')
                : `<tr><td colspan="2">${lang.get('messages.sin_registros') ?? 'Sin registros'}</td></tr>`;

            const title = `Historial - ${this.props.title}`;

            await swal.fire({
                title,
                html: `
                    <div class="table-responsive" style="max-height: 500px; overflow: auto;">
                        <table class="table table-sm table-borderless m-0">
                            <thead>
                                <tr>
                                    <th style="white-space:nowrap;">Fecha</th>
                                    <th>Estatus</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${rowsHtml}
                            </tbody>
                        </table>
                    </div>
                `,
                icon: 'info',
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.cerrar') ?? 'Cerrar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        } catch (error) {
            window.unblockUI();
            const message = getErrorsMessage(error);
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        }
    }

    deleteDocument = (title)=>{
        const { lang } = this.context; 
        swal.fire({ 
            html: '¿Estás seguro que deseas borrar el documento '+ title +'?<div class="mt-5 col-md-12 alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert"> <div> <span class="flaticon2-warning mr-2 icon-3x"></span> </div> <div>  Es importante considerar ya que una vez que se borre el documento no habrá forma de recuperarlo. </div> </div>',
            showCancelButton: true, 
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: 'Borrar',
            cancelButtonText:  lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) { 
                axios.post('/api/document_dossier/documents/delete',{
                    ids:[this.props.document.id]
                }).then(res=>{
                    swal.fire({
                        text: 'Se ha borrado el documento',
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText:lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        location.reload()
                    });
                })
            }
        });
    }
    async componentDidMount() {

    }

    render() {
        const { lang } = this.context;
        console.log(this.props.permissions?.documents_actions)
        const canViewDocument = this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('view_document');
        const isRejectedSection = this.props.section === 'rejected';
        const canDeleteDocument = this.props.user_mode == 'client' && !isRejectedSection && (this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('delete_document'));
        const canViewStatusLog = this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('status_log');
        const canShowActions = canViewDocument || canDeleteDocument || canViewStatusLog;

        if (!canShowActions) {
            return null;
        }

        return (
            <div className="d-flex justify-content-end">
                <div className="dropdown dropdown-inline">
                    <a href="#" class="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {lang.get('messages.acciones')}
                        &nbsp;&nbsp;
                        <i class="flaticon2-down icon-sm"></i>
                    </a>
                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg"  >
                        <ul className="navi navi-hover">
                         
                            {canViewDocument && (
                                <li className="navi-item">  
                                    <a href={"/document_dossier/" + this.props.person_provider_id +"/"+ this.props.param +"/" + this.props.document.id} class="navi-link py-4">
                                        <span className="navi-icon mr-5 text-center">
                                            <span className="flaticon2-file-1 text-primary icon-md"></span>
                                        </span> 
                                        <span className="navi-text text-secondary">{lang.get('messages.ver_documento')}</span>
                                        <span className="navi-icon pull-right">
                                            <button className="btn btn-icon btn-light btn-xs bg-white">
                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                            </button>
                                        </span>
                                    </a>
                                </li>
                            )}
                            {canDeleteDocument && (
                                <>
                                    <li className="navi-item">
                                    <a onClick={  () => this.deleteDocument(this.props.title) } class="navi-link py-4">
                                        <span className="navi-icon mr-5 text-center">
                                            <span className="flaticon-delete fw-normal text-primary icon-md"></span>
                                        </span>
                                        <span className="navi-text text-secondary">Borrar documento  </span>
                                        <span className="navi-icon pull-right">
                                            <button className="btn btn-icon btn-light btn-xs bg-white">
                                                <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                            </button>
                                        </span>
                                    </a>
                                </li> 
                                </>
                            )}
                            {canViewStatusLog && (
                               <li className="navi-item">  
                                <a onClick={this.viewDocumentHistory} class="navi-link py-4">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon2-time text-primary icon-md"></span>
                                    </span> 
                                    <span className="navi-text text-secondary">Bitácora de estatus</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            )}
                        </ul>
                    </div>
                </div> 
            </div>
        );
    }
}

export default DocumentsActions;

if (document.getElementById('DocumentsActions')) {
    ReactDOM.render(<DocumentsActions />, document.getElementById('DocumentsActions'));
}
